// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

// Components
import TableComponent from '../../TableComponent';
import SectionTitle from '../../SectionTitle';
import CircularProgress from '@mui/material/CircularProgress';

// Queries
import getViaje from '../../Queries/getViaje';

// Styles
import styles from './index.module.sass';

// Images
import logoVI from './images/logoVI-2.png';
import logoVN from './images/logoVN-2.png';

const maintenance = false;

const Travel = (props) => {
  const { pathname } = useLocation();
  const { device, webservice, getCookie } = props;
  const { screenSize } = device;
  const [principalTable, setPrincipalTable] = useState([]);
  const [detailTable, setDetailTable] = useState([]);
  const [sponsoringTable, setSponsoringTable] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showImageDiealog, setShowImageDialog] = useState(false);
  const { t } = useTranslation('travel');

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const res = await getViaje({
        jsonBody: {
          usuarioOk: getCookie('usuarioOk'),
          viaje: pathname.includes('nationaltravel') ? 'N' : 'I',
        },
      });

      const { typeMessage = 'error', data = {} } = res || {};

      if (typeMessage === 'error') return null;
      const { Detalle = [], Patrocinios = [] } = data;
      setPrincipalTable([res?.data]);
      setDetailTable(Detalle || []);
      setSponsoringTable(Patrocinios || []);

      setLoading(false);
    }
    if (!maintenance) fetchData();
  }, [getCookie, webservice, t, pathname]);

  const principalHeader = t('principalHeader', { returnObjects: true });

  const detailHeader = t('detailHeader', { returnObjects: true });

  const sponsoringHeader = t('sponsoringHeader', { returnObjects: true });

  console.log(principalTable[0]?.baseDelViaje, 'principalTable');

  return (
    <div id={styles.Travel} className={`${styles.travel} ${styles[screenSize]}`}>
      {showImageDiealog && (
        <div className={styles.imageDialog}>
          <div className={styles.closeIcon} onClick={() => setShowImageDialog(false)}>
            <i className={`material-icons-outlined`}>close</i>
          </div>
          <img
            src={`https://webimages.terramarbrands.com.mx/usawebpage/travel/bases/${
              principalTable[0]?.baseDelViaje
            }${screenSize === 'phone' ? '-mobile' : ''}.webp`}
            alt='travel bases'
            className={styles.travelImage}
          />
        </div>
      )}
      <SectionTitle
        title={pathname.includes('nationaltravel') ? t('title2') : t('title')}
        subtitle={pathname.includes('nationaltravel') ? t('subtitle2') : t('subtitle')}
      />

      <div className={styles.logoContainer}>
        <img
          src={pathname.includes('nationaltravel') ? logoVN : logoVI}
          alt='travel logo'
          className={styles.logoImage}
        />
      </div>
      <div className={styles.container}>
        {(maintenance && (
          <div className={styles.maintenance}>
            <div className={styles.maintenanceTitle}>{t('maintenance')}</div>
            <div>{t('soon')}</div>
          </div>
        )) || (
          <>
            <div className={styles.tableHeader}>
              <div className={styles.tableTitle}>{t('principalTitle')}</div>
              {!pathname.includes('nationaltravel') && (
                <div onClick={() => setShowImageDialog(true)} className={styles.showBasesTableText}>
                  Ver tabla de bases
                </div>
              )}
            </div>
            {(loading && <CircularProgress className={styles.circularProgress} />) || (
              <TableComponent
                screenSize={screenSize}
                tableData={principalTable}
                tableItems={principalHeader}
              />
            )}

            <div className={styles.tableTitle}>{t('detailTitle')}</div>
            {(loading && <CircularProgress className={styles.circularProgress} />) || (
              <TableComponent
                screenSize={screenSize}
                tableData={detailTable}
                tableItems={detailHeader}
              />
            )}

            <div className={styles.tableTitle}>{t('sponsoredTitle')}</div>
            {(loading && <CircularProgress className={styles.circularProgress} />) || (
              <TableComponent
                screenSize={screenSize}
                tableData={sponsoringTable}
                tableItems={sponsoringHeader}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Travel;
